import React from 'react';
import ChatContactInfo from '../../inbox/components/ChatContactInfo';

interface ChatContactInfoModalProps {
    open: boolean;
    contact: {
        name: string;
        company: string;
        email: string;
        phone: string;
        value: string;
        stage: string;
    };
    onClose: () => void;
}

const ChatContactInfoModal: React.FC<ChatContactInfoModalProps> = ({ open, contact, onClose }) => {
    return (
        <>
            {open && (
                <div className="flex-1 overflow-y-auto flex flex-col gap-6 p-6">
                    <ChatContactInfo contact={contact} isOpen={open} onClose={onClose} />
                </div>
            )}
        </>
    );
};

export default ChatContactInfoModal;
